import { gql } from "@apollo/client";

import { TRANSACTION_FRAGMENT } from "@graphql/fragments";

export const TRANSACTIONS = gql`
  ${TRANSACTION_FRAGMENT}
  query transactions($size: Int, $time: TransactionTime, $cursor: String) {
    transactions(input: { size: $size, time: $time, cursor: $cursor }) {
      elements {
        ...TransactionFragment
      }
      size
      nextCursor
    }
  }
`;

export const AVAILABLE_TO_WITHDRAW_IN_CENTS = gql`
  query availableToWithdrawInCents($goalId: String!, $subaccountId: String) {
    availableToWithdrawInCents(input: { goalId: $goalId, subaccountId: $subaccountId }) {
      netAvailableToWithdrawInCents
      grossAvailableToWithdrawInCents
      pendingContributionsInCents
      pendingWithdrawalsInCents
      isWithdrawalAllInitiated
      lockedPromotionalDollarsInCents
    }
  }
`;

export const IS_WITHDRAWAL_ALLOWED = gql`
  query isWithdrawalAllowed($goalId: String!, $subaccountId: String) {
    isWithdrawalAllowed(input: { goalId: $goalId, subaccountId: $subaccountId }) {
      allowed
      cancellationRequired
      reason
    }
  }
`;

export const FAILED_ACH_CONTRIBUTION = gql`
  ${TRANSACTION_FRAGMENT}
  query failedAchContribution {
    failedAchContribution {
      id
      transactionId
      returnCode
      returnReason
      occurrenceNumber
      createdAt
      failedTransaction {
        ...TransactionFragment
      }
    }
  }
`;
